
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import sv from '@drawbotics/drylus-style-vars';
import { css, cx } from '@emotion/css';
import {
  Grid,
  GridItem,
  Size,
  Tooltip,
  Icon,
  useAlert,
  Category,
} from '@drawbotics/react-drylus';
import {
  greys,
  neutrals,
  azures,
  brands,
  reds,
  greens,
  oranges,
  blues,
  pinks,
  purples,
  violets,
  yellows,
} from './palettes';
export const styles = {
  palette: css`
    border-radius: ${sv.defaultBorderRadius};
    overflow: hidden;
  `,
  header: css`
    padding: ${sv.paddingSmall};
    color: ${sv.colorPrimaryInverse};
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  title: css`
    text-transform: uppercase;
    font-size: 0.9rem;
  `,
  color: css`
    padding: ${sv.paddingSmall};
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: ${sv.transitionShort};
    position: relative;
    &::after {
      content: ' ';
      position: absolute;
      bottom: -10px;
      left: 0;
      height: 10px;
      width: 100%;
      background: currentColor;
    }
    &:hover {
      cursor: pointer;
      transform: translateY(-10px);
    }
    > div {
      color: ${sv.colorPrimaryInverse};
    }
    input {
      opacity: 0;
      pointer-events: none;
      width: 0;
    }
  `,
  light: css`
    > div {
      color: ${sv.colorPrimary};
    }
  `
};
export const Palette = ({
  palette
}) => {
  const {
    colors,
    title,
    background,
    description
  } = palette;
  const {
    showAlert
  } = useAlert();
  const copyToClipboard = async name => {
    const target = document.querySelector(`[data-element="${name}"]`);
    await navigator.clipboard.writeText(target.value);
    showAlert({
      category: Category.INFO,
      text: `Color code ${target.value} copied to clipboard!`
    });
  };
  return <div className={styles.palette}>
      <div className={styles.header} style={{
      background
    }}>
        <div className={styles.title}>{title}</div>
        {description != null ? <Tooltip content={description} mdxType="Tooltip">
            <Icon name="info" mdxType="Icon" />
          </Tooltip> : null}
      </div>
      {colors.map((color, i) => <div onClick={() => copyToClipboard(color.name)} key={i} style={{
      background: sv[color.name],
      color: sv[color.name]
    }} className={cx(styles.color, {
      [styles.light]: color.light
    })}>
          <div>{color.name}</div>
          <input type="text" data-element={`${color.name}`} value={`${sv[color.name]}`} readOnly />
          <div style={{
        textTransform: 'uppercase'
      }}>{sv[color.name]}</div>
        </div>)}
    </div>;
};
export const Colors = ({
  palettes
}) => {
  return <Grid columns={3} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} responsive={{
    L: {
      columns: 2
    },
    M: {
      columns: 1
    }
  }} mdxType="Grid">
      {palettes.map((p, i) => <GridItem key={i} mdxType="GridItem">
          <Palette palette={p} mdxType="Palette" />
        </GridItem>)}
    </Grid>;
};

const layoutProps = {
  styles,
Palette,
Colors
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





<h1>{`Colors`}</h1>
<h3>{`Basics`}</h3>
<p>{`These are used for elements which shouldn't bring much attention to the user, rather used to create separation between layers, or add texture.`}</p>
<Colors palettes={[greys, neutrals, azures]} mdxType="Colors" />
<h3>{`Highlights`}</h3>
<p>{`These are the colors you will be using most often, since they represent statuses, are used for actions (desctructive, informative etc.) to help understand which elements of the page the user should focus on.`}</p>
<Colors palettes={[reds, oranges, blues, greens, brands]} mdxType="Colors" />
<h3>{`Complementary`}</h3>
<p>{`Additional colors used mostly for charts and other stylistic reasons`}</p>
<Colors palettes={[pinks, violets, purples, yellows]} mdxType="Colors" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;